import React from 'react'
import { selectUserId, setAdminMode } from '../../store/actions/dataActions'
import { ToggleButton } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'


const AdminButton = () => {
  
  const adminMode = useSelector(state => state.data.adminMode)
  const dispatch = useDispatch()
  
  return (
    <ToggleButton
      value='adminMode'
      selected={adminMode || false}
      onChange={() => {
        dispatch(setAdminMode(!adminMode))
        if (adminMode) {
          dispatch(selectUserId(null))
        }
      }}
      size='small'
      sx={{
        color: 'white',
        py: .5,
        '&.Mui-selected': {
          color: 'white',
          backgroundColor: 'secondary.dark',
          '&:hover': {
            backgroundColor: 'secondary.dark',
          },
        },
      }}
    >
      MODE ADMIN
    </ToggleButton>
  )
  
}

export default AdminButton
